"use strict";
// This store doesn't use MobX decorators
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollStore = void 0;
var ScrollStore = /** @class */ (function () {
    function ScrollStore() {
        Object.defineProperty(this, "scrollYDictionary", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    Object.defineProperty(ScrollStore.prototype, "setScrollY", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (scrollY) {
            var _a;
            var pathname = (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname;
            //console.log("setScrollY: pathname: ", pathname, "scrollY: ", scrollY);
            if (pathname) {
                this.scrollYDictionary[pathname] = scrollY;
            }
            else {
                console.log("setScrollY: ", pathname, " is undefined");
            }
        }
    });
    Object.defineProperty(ScrollStore.prototype, "getScrollY", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            var pathname = (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname;
            //console.log("getScrollY: pathname: ", pathname);
            if (pathname) {
                return this.scrollYDictionary[pathname];
            }
            else {
                console.log("getScrollY: ", pathname, " is undefined");
                return 0;
            }
        }
    });
    return ScrollStore;
}());
exports.ScrollStore = ScrollStore;
exports.default = new ScrollStore();
